import Vue from 'vue'
import Vuei18n from 'vue-i18n'
import en from './en.json'
import fr from './fr.json'

Vue.use(Vuei18n)

const i18n = new Vuei18n({
    locale: localStorage.getItem('locale') || 'fr',
    messages:{
        en,
        fr
    }
})

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js